import { MobileOnly, Stack } from "@/components/ui";
import type { Area, OrganizacionAdmin, UsuarioAdmin } from "@/lib/types";
import { UsuarioMobileCard } from "./UsuarioMobileCard";

export function UsuariosMobileList({
  usuarios,
  todasAreas,
  todasOrganizaciones,
  editandoId,
  onToggleEditar,
}: {
  usuarios: UsuarioAdmin[];
  todasAreas: Area[];
  todasOrganizaciones: OrganizacionAdmin[];
  editandoId: string | null;
  onToggleEditar: (id: string) => void;
}) {
  return (
    <MobileOnly>
      <Stack gap="xs">
        {usuarios.map((u) => (
          <UsuarioMobileCard
            key={u.id}
            u={u}
            expandida={editandoId === u.id}
            onToggle={() => onToggleEditar(u.id)}
            todasAreas={todasAreas}
            todasOrganizaciones={todasOrganizaciones}
          />
        ))}
      </Stack>
    </MobileOnly>
  );
}
